module.exports = __webpack_public_path__ + "static/media/400039_01.7631ffc6.png";